import { Controller } from "@hotwired/stimulus"
import { plugin } from "../native"

// Native share sheet (Capacitor Share) -> Web Share API -> button stays hidden (the page has plain links as well).
export default class extends Controller {
  static targets = ["button"]
  static values = { title: String, text: String, url: String }

  connect() {
    this.buttonTarget.hidden = !(plugin("Share") || navigator.share)
  }

  async share() {
    const data = { title: this.titleValue, text: this.textValue, url: this.urlValue }
    try {
      const native = plugin("Share")
      if (native) await native.share({ ...data, dialogTitle: this.titleValue })
      else await navigator.share(data)
    } catch (_cancelled) { /* closing the sheet is not an error */ }
  }
}
